import "./SiteInformation.html";

import "./EditSiteInformation/EditSiteInformationComponent";

import type { IComponentOptions, IControllerConstructor, Injectable } from "angular";
import { module } from "angular";
import SiteInformationComponentController from "./SiteInformationComponentController";

export default class SiteInformationComponent implements IComponentOptions {
    public bindings: any;

    public controller: Injectable<IControllerConstructor>;

    public templateUrl: string;

    constructor() {
        this.bindings = {
            site: "<",
        };
        this.controller = SiteInformationComponentController;
        this.templateUrl = "/App/Components/Site/Overview/SiteInformation/SiteInformation.html";
    }
}

module("mmManagePortal").component("mmSiteInformation", new SiteInformationComponent());
